import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function Pricing() {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    api.get("/plans")
      .then((res) => setPlans(res.data))
      .catch((err) => console.error(err));
  }, []);
  
  const handlePayment = async (planSlug) => {
  try {
    const { data } = await api.post("/payment/create-order", {
      plan_slug: planSlug,
    });

    const options = {
      key: data.razorpay_key,
      amount: data.amount,
      currency: data.currency,
      name: "MigrateFlow",
      description: data.plan.name + " Plan",
      order_id: data.order_id,

      handler: async function (response) {

            try {
        
                const verify = await api.post("/payment/verify", {
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_signature: response.razorpay_signature,
                });
        
                console.log(verify.data);
        
                alert("Payment Successful!");
        
            } catch (err) {
        
                console.error(err);
        
                alert("Payment Verification Failed");
        
            }
        
        },

      theme: {
        color: "#2563eb",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (err) {
    console.error(err);
    alert("Payment initialization failed");
  }
};


  return (
    <div style={{ padding: "50px" }}>
      <h1 style={{ textAlign: "center" }}>Choose Your Plan</h1>

      <div
        style={{
          display: "flex",
          gap: "20px",
          justifyContent: "center",
          flexWrap: "wrap",
          marginTop: "40px",
        }}
      >
        {plans.map((plan) => (
          <div
            key={plan.slug}
            style={{
              width: "320px",
              border: "1px solid #ddd",
              borderRadius: "10px",
              padding: "25px",
              boxShadow: "0 5px 15px rgba(0,0,0,.08)",
            }}
          >
            <h2>{plan.name}</h2>

            <h1>
              ₹{plan.price}
              <span style={{ fontSize: "16px" }}>/month</span>
            </h1>

            <p>{plan.mailbox_limit} Mailboxes</p>

            <p>{plan.migration_limit} Migrations</p>

            <p>{plan.support} Support</p>

            <ul>
              {plan.features.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>

            <button
              onClick={() => handlePayment(plan.slug)}
              style={{
                width: "100%",
                padding: "12px",
                background: "#2563eb",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Choose Plan
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}